import { isNumber } from "#shared/helpers/isNumber";

export const formatSimilarityScore = (score: number | undefined | null, precision = 0) =>
  isNumber(score) && score >= 0 ? Math.min(Number((score * 100).toFixed(precision)), 100) : 0;
